import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import http from '../../shared/http'
import i18nInstance from '../../shared/i18n'
import { TApi } from '../../shared/const'
import { formatVienna } from '../../shared/datetime'

import styles from './style.module.scss'

/**
 * Die Prüfseite einer Kurs-Urkunde — das Ziel des QR-Codes auf dem Blatt.
 *
 * Öffentlich, weil sie ein Betrieb aufruft, der keinen Zugang hat. Sie sagt
 * deshalb nur, was zur Echtheit nötig ist: gültig, welcher Kurs, wann, und
 * auf wen (Vorname und Anfangsbuchstabe). Mehr steht auf dem Blatt selbst.
 */
export default function CourseCertificateCheck() {
	const { t } = useTranslation()
	const { code } = useParams()
	const isAuth = useSelector(state => state.user.isAuth)
	const [stand, setStand] = useState({ status: 'loading' })

	// Ohne Anmeldung gibt es keine Sprachwahl; die Seite spricht Deutsch.
	useEffect(() => {
		if (!isAuth && i18nInstance.language !== 'ger') i18nInstance.changeLanguage('ger')
	}, [isAuth])

	useEffect(() => {
		http.get(TApi.PUBLIC_COURSE_CERTIFICATE(code), { disableToast: true })
			.then(({ data }) => setStand({ status: data?.valid ? 'valid' : 'invalid', data }))
			.catch(() => setStand({ status: 'invalid' }))
	}, [code])

	return (
		<div className={styles.root}>
			<div className={styles.card}>
				<span className={styles.label}>Junior Achievement Austria</span>
				<h1 className={styles.title}>{t('Certificate check')}</h1>

				{stand.status === 'loading' && <p>{t('Checking…')}</p>}

				{stand.status === 'valid' && (
					<>
						<p className={styles.valid}>✓ {t('This certificate is genuine.')}</p>
						<dl className={styles.facts}>
							<dt>{t('Course')}</dt>
							<dd>{stand.data.courseTitle}</dd>
							<dt>{t('Awarded to')}</dt>
							<dd>{stand.data.holder}</dd>
							<dt>{t('Completed on')}</dt>
							<dd>{formatVienna(stand.data.completedAt, 'dd.MM.yyyy')}</dd>
							<dt>{t('Issued by')}</dt>
							<dd>{stand.data.issuer || 'Junior Achievement Austria'}</dd>
							<dt>{t('Check code')}</dt>
							<dd className={styles.code}>{code}</dd>
						</dl>
					</>
				)}

				{stand.status === 'invalid' && (
					<p className={styles.invalid}>
						{t('No certificate with this check code was found. Please compare the code with the one on the certificate.')}
					</p>
				)}
			</div>
		</div>
	)
}
